import { useMemo } from 'react'

import {
  getPermissions,
  hasPermission,
  hydratePermissions,
  type Permission,
} from '@mntn-dev/authorization-types'
import { usePrincipal } from './use-principal.ts'

function usePermissions() {
  const { principal } = usePrincipal()

  // Merge the legacy permissions with the new permissions until we see where this goes
  // TODO: Remove all the legacy permission functions if/when it comes to it.
  const permissions = useMemo(
    () => ({
      ...getPermissions(principal.privileges),
      hasPermission: (permission: Permission) =>
        hasPermission(hydratePermissions(principal), permission),
    }),
    [principal]
  )

  return permissions
}

type HasPermission = (permission: Permission) => boolean

export { usePermissions, type HasPermission }
